import { Box, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { styles } from './tare-weight-percentage-styles';

const TareWeightPercentage: React.FC<ITareWeightPercentage> = (props): JSX.Element => {
  const classes = styles();

  const handleSelectedTareWeightPercentage = (value: number): void => {
    props.handleSelection(value);
  };

  return (
    <Box className={`${classes.productBox}`}>
      <Grid
        className={`
          ${classes.tarePercentageCard}
          product-container`}
        data-testid='tare-weight-percentage-item-list'
        onClick={(): void => handleSelectedTareWeightPercentage(props.tarePercentage)}
      >
        <Typography className={classes.tarePercentageCardHeader}>
          {props.tarePercentage}%
        </Typography>
      </Grid>
    </Box>
  );
};

interface ITareWeightPercentage {
  handleSelection: (value: number) => void;
  tarePercentage: number;
}

export default TareWeightPercentage;
